/** Déballage des réponses Laravel (Resource, collection paginée ou tableau brut). */
export function unwrapList<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === 'object') {
    const obj = payload as Record<string, unknown>;
    if (Array.isArray(obj.data)) return obj.data as T[];
    if (obj.data && typeof obj.data === 'object' && Array.isArray((obj.data as { data: unknown }).data)) {
      return (obj.data as { data: T[] }).data;
    }
  }
  return [];
}

export function unwrapItem<T>(payload: unknown): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    const inner = (payload as { data: unknown }).data;
    if (inner && typeof inner === 'object' && 'data' in (inner as object)) {
      return (inner as { data: T }).data;
    }
    return inner as T;
  }
  return payload as T;
}
